import { render, staticRenderFns } from "./section-card.vue?vue&type=template&id=1da32430&functional=true&"
import script from "./section-card.vue?vue&type=script&lang=js&"
export * from "./section-card.vue?vue&type=script&lang=js&"
import style0 from "./section-card.vue?vue&type=style&index=0&id=1da32430&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports